import * as React from "react";

const PasswordForm = () => {
  return (
      <div >
          <p>Password Requirements:</p>
          <ul style={{margin: "0px 0"}}>
              <li>at least 10 characters long</li>
              <li>at least one uppercase letter</li>
              <li>at least one lowercase letter</li>
              <li>at least one number</li>
              <li>at least one special character</li>
          </ul>
      </div>
  )
};
export default PasswordForm;
